import { createStore } from 'vuex'

const state = {
    appLoaded: false,
    pageType: "",
    selected_charity: "",
    text_search_charity: "",
    selected_event: "",
    res_text_search_event: "",
    selected_teampage: "",
    search_join_team: "",
    loginStatus: "login",
    data_params_pre: {
        beneficiaryId: "",
        eventId: "",
        teamId: ""
    },

    login: "",
    userLogon: "",
    externalId: "",

    details_team: {
        teamName: "",
        teamTarget: "",
        router_name: "",
        createIndividualPage: true
    },
    creatingPage: false,
    activationId: null,
    userIsActivatingCreatedPage: false,
    pageId: "",
    apiDomain: "",
    referrer: "",
    region: "au",
    regionId: "eedd16d2-38b3-459e-b2d4-5ba898524018",
    captchaPublicKey: "",
    registerUrl: "/account/register",
    alertMsg: "",
    accessToken: "",
    accountLink: false,
    tokenErrorMessage: { message: "", time: new Date() },
    shouldLinkAccount: false,    
    createType :"",
    isRegister : false,
    isCreatingNewUser: false,
    disclaimerText: '',
    auth: {
      provider: [
        {
          name: "",
          details: {
            aws_project_region: "",
            aws_cognito_identity_pool_id: "",
            aws_cognito_region: "",
            aws_user_pools_id: "",
            aws_user_pools_web_client_id: "",
            oauth: {},
          }
        }
      ],
      facebook: {
        appId : "",
        scope: "",
        state:"",
        redirectUrl: ""
      },
    }
};

const mutations = {
    setAuthProvider(state, payload) {
      state.auth.provider = payload
    },

    setAuthFacebook(state, payload) {
      state.auth.facebook = payload
    },

    setAuthFacebookAppId(state, payload) {
      state.auth.facebook.appId = payload
    },

    setAuthFacebookScope(state, payload) {
      state.auth.facebook.scope = payload
    },

    setAuthFacebookState(state, payload) {
      state.auth.facebook.state = payload
    },

    setAuthFacebookRedirectUrl(state, payload) {
      state.auth.facebook.redirectUrl = payload
    },

    setDisclaimerText(state, payload) {
        state.disclaimerText = payload;
    },

    appReadyForUserInput(state) {
        state.appLoaded = true;
    },
    setCreateType(state, payload){
        state.createType = payload;
    },
    
    change_Beneficiary(state, payload) {
        state.selected_charity = payload;
    },
    res_search_text_charity(state, payload) {
        state.text_search_charity = payload;
    },

    change_event(state, payload) {
        state.selected_event = payload;
    },

    res_text_search_event(state, payload) {
        state.res_text_search_event = payload;
    },

    change_jointeam_data(state, payload) {
        state.selected_teampage = payload;
    },
    res_text_search_jointeam(state, payload) {
        state.search_join_team = payload;
    },

    pre_BeneficiaryId(state, payload) {
        state.data_params_pre.beneficiaryId = payload;
    },
    pre_EventId(state, payload) {
        state.data_params_pre.eventId = payload;
    },
    pre_TeamId(state, payload) {
        state.data_params_pre.teamId = payload;
    },

    preUserLogin(state, payload) {
        state.userLogon = payload;
    },

    pre_ExternalId(state, payload) {
        state.externalId = payload;
    },

    pre_Login(state, payload) {
        state.login = payload;
    },

    teamNameChange(state, payload) {
        state.details_team.teamName = payload;
    },

    teamTargetChange(state, payload) {
        state.details_team.teamTarget = payload;
    },

    selected_details(state, payload) {
        state.details_team.router_name = payload;
    },

    createIndividualPageChange(state, payload) {
        state.details_team.createIndividualPage = payload;
    },

    setPageType(state, payload) {
        state.pageType = payload;
    },

    setIsRegister(state, payload) {
        state.isRegister = payload;
    },

    setIsCreatingNewUser(state, payload) {
        state.isCreatingNewUser = payload;
    },

    setApiDomain(state, payload) {
        state.apiDomain = payload;
    },

    setReferrer(state, payload) {
        state.referrer = payload;
    },

    setActivationId(state, payload) {
        if (payload == "") payload = null;

        state.userIsActivatingCreatedPage = !(
            payload === null || payload.length === 0
        );
        state.activationId = payload;
    },

    setPageId(state, payload) {
        state.pageId = payload;
    },

    setRegion(state, payload) {
        state.region = payload;
    },

    setRegionId(state, payload) {
        state.regionId = payload;
    },

    setCaptchaKey(state, payload) {
        state.captchaPublicKey = payload;
    },

    setRegisterUrl(state, payload) {
        state.registerUrl = payload;
    },

    setFacebookScope(state, payload) {
        state.facebookScope = payload;
    },

    setFacebookAppId(state, payload) {
        state.facebookAppId = payload;
    },

    setRedirectUrl(state, payload) {
        state.redirectUrl = payload;
    },

    setLoginStatus(state, payload) {
        state.loginStatus = payload;
    },

    setAlertMsg(state, payload) {
        state.alertMsg = payload;
    },

    setAccessToken(state, token) {
        state.accessToken = token;
        state.shouldLinkAccount = state.accountLink && state.accessToken && state.accessToken.length > 0;
    },

    setAccountLinkMode(state, mode) {
        state.accountLink = mode;
        state.shouldLinkAccount = state.accountLink && state.accessToken && state.accessToken.length > 0;
    },

    setTokenErrorMessage(state, payload) {
        state.tokenErrorMessage = payload;
    },

    resetCreatingPageState(state) {
        state.creatingPage = false
    },

    creatingPage(state) {
        state.alertMsg = '';
        state.creatingPage = true;
    }
};

const store = createStore({
  state: state,
  mutations: mutations
});

export default store
